export const GIFT_CARD_CODE_UNSANITIZED_LENGTH = 19;
